import React from 'react'
import { InputAdornment, InputAdornmentProps } from '@mui/material'

const InputAdornmentWrapper: React.FC<InputAdornmentProps> = ({ ...props }) => (
  <InputAdornment {...props} />
)

export default InputAdornmentWrapper
